<template>
  <!-- Add Holiday Modal -->
  <div class="modal custom-modal fade" id="add_holiday" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Holiday</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="addHoliday">
            <div class="input-block mb-3">
              <label class="col-form-label"
                >Holiday Title <span class="text-danger">*</span></label
              >
              <input class="form-control" v-model="title" value="New Year" type="text" />
            </div>
            <div class="input-block mb-3">
              <label class="col-form-label"
                >Holiday Date <span class="text-danger">*</span></label
              >
              <div class="cal-icon">
                <date-picker
                  v-model="date"
                  placeholder="DD-MM-YYYY"
                  class="form-control datetimepicker"
                  :editable="true"
                  :clearable="false"
                  :inputFormat="dateFormat"
                />
              </div>
            </div>
            <div class="submit-section">
              <button class="btn btn-primary submit-btn" type="submit" data-bs-dismiss="modal">Save</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Holiday Modal -->
  <!-- Edit Holiday Modal -->
  <div class="modal custom-modal fade" id="edit_holiday" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Holiday</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="updateHoliday">
            <div class="input-block mb-3">
              <label class="col-form-label"
                >Holiday Title <span class="text-danger">*</span></label
              >
              <input class="form-control" v-model="holidayTitle" value="New Year" type="text" />
            </div>
            <div class="input-block mb-3">
              <label class="col-form-label"
                >Holiday Date <span class="text-danger">*</span></label
              >
              <div class="cal-icon">
                <date-picker
                  v-model="holidayDate"
                  placeholder="DD-MM-YYYY"
                  class="form-control datetimepicker"
                  :editable="true"
                  :clearable="false"
                  :inputFormat="dateFormat"
                />
              </div>
            </div>
            <div class="submit-section">
              <button class="btn btn-primary submit-btn" type="submit" data-bs-dismiss="modal">Save</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Holiday Modal -->

  <!-- Delete Holiday Modal -->
  <div class="modal custom-modal fade" id="delete_holiday" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Delete Holiday</h3>
            <p>Are you sure want to delete?</p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  class="btn btn-primary continue-btn" @click="deleteClicked" data-bs-dismiss="modal"
                  >Delete</a
                >
              </div>
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  data-bs-dismiss="modal"
                  class="btn btn-primary cancel-btn"
                  >Cancel</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Holiday Modal -->
</template>

<script>
import { ref } from "vue";
import axios from "axios";
import {VUE_APP_API_BASE_URL} from "../../config";
const currentDate = ref(new Date());
const currentDateOne = ref(new Date());
export default {
  emits: ["holidayModel"],
  data() {
    return {
      startdateone: currentDate,
      dateFormat: 'dd/MM/yyyy',
      startdate: currentDateOne,
      holidayId:null,
      holidayTitle:null,
      holidayDate:null,
      title:null,
      date:null,
    };
  },
  methods:{
    edit(item){
      this.holidayId = item.id;
      this.holidayTitle = item.title;
      this.holidayDate = new Date(this.convertDayMonthToDate(item.day, item.month));
    },
    convertDayMonthToDate(day,month){
      let year = new Date().getFullYear();
      day = ''+day;
      month = ''+month;
      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;
      return `${year}-${month}-${day}`;
    },
     async addHoliday(){
      await axios.post(`${VUE_APP_API_BASE_URL}/holiday/add`,{
        title:this.title,
        date:this.date
      }).then((response)=>{

        if(response.data.status){
          this.$emit("holidayModel");
          this.$toast.success(response.data.message);
        }else{
          this.$toast.error(response.data.message || response.data.errors);
        }
      }).catch(function (error){
        console.log('error ',error);
      });
    },
    async updateHoliday(){
      await axios.post(`${VUE_APP_API_BASE_URL}/holiday/${this.holidayId}/update`,{
        title:this.holidayTitle,
        date:this.holidayDate
      }).then((response)=>{
        if(response.data.status){
          this.$emit("holidayModel");
          this.$toast.success(response.data.message);
        }
      }).catch(function (error){
        console.log('error ',error);
      });
    },
    delete(id){
      this.holidayId = id;
    },
    async deleteClicked(){
      await axios.post(`${VUE_APP_API_BASE_URL}/holiday/${this.holidayId}/delete`).then((response)=>{
        if(response.data.status){
          this.$emit("holidayModel");
          this.$toast.success(response.data.message);
        }
      }).catch(function (error){
        console.log(error);
      });
    }
  }
};
</script>
